module.exports = __webpack_public_path__ + "img/avatar_random_18.fa1ae894.png";